"use client";

import React from "react";
import { useRouter } from "src/i18n/navigation";
import { Box, Button, Typography } from "@mui/material";
import { useAppTranslate } from "src/hooks/useAppTranslate";
import { GetOrderDto } from "src/services/generated-api";
import { getGuestTokenCookies } from "src/services/api";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";

import { PaymentOption } from "src/enums/payment-option";
import { resumeUrlFor } from "@components/order/utils/resume-destination";

const ResumeOldOrder = ({
  title,
  paymentOption,
  orderId,
  shippingEmail,
}: {
  title: string;
  paymentOption: PaymentOption | null | undefined;
  orderId: string | null | undefined;
  /**
   * The order's email, if it already has one. Decides whether resuming may skip
   * the photo-options step — see handleContinueOldOrder.
   */
  shippingEmail?: string | null;
}) => {
  const router = useRouter();
  const t = useAppTranslate();

  const handleContinueOldOrder = () => {
    const guestToken = getGuestTokenCookies();

    // The rule (and why it exists) lives in resumeStepFor -- shared with the
    // unfinished-order modal so the two cannot drift apart.
    router.push(
      resumeUrlFor(
        window.location.origin,
        orderId ?? undefined,
        { shippingEmail, paymentOption },
        guestToken,
      ),
    );
  };

  return (
    <Box
      textAlign="center"
      my={2}
      sx={{
        border: "2px solid",
        borderColor: "primary.main",
        borderRadius: "10px",
        padding: "10px",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
      }}
    >
      <Typography variant="body1" fontWeight="bold" my={1}>
        {title}
      </Typography>
      <Button
        onClick={handleContinueOldOrder}
        variant="contained"
        startIcon={<ShoppingCartCheckoutIcon />}
        sx={{ color: "primary.contrastText", my: "10px" }}
      >
        {t("orderHistory.continue")}
      </Button>
    </Box>
  );
};

export default ResumeOldOrder;
